import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useCallback } from 'react';

import type { SetSolanaAddress } from '@sorare/wallet-shared/src/contexts/messaging';

import { useMessagingContext } from '#src/contexts/wallet/index.ts';
import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  SetSolanaMutation,
  SetSolanaMutationVariables,
} from './__generated__/useSetSolanaAddress.graphql.ts';

const SET_SOLANA_ADDRESS_MUTATION = gql`
  mutation SetSolanaMutation($input: addSolanaAddressInput!) {
    addSolanaAddress(input: $input) {
      currentUser {
        slug
        wallet {
          id
          solanaAddress
        }
      }
    }
  }
` as TypedDocumentNode<SetSolanaMutation, SetSolanaMutationVariables>;

export const useSetSolanaAddress = () => {
  const { sendRequest } = useMessagingContext();

  const [mutate] = useMutation(SET_SOLANA_ADDRESS_MUTATION);

  return useCallback(async () => {
    const result = await sendRequest<SetSolanaAddress>('setSolanaAddress', {});
    if (result.result) {
      const { solanaAddress } = result.result;
      return mutate({ variables: { input: { solanaAddress } } });
    }
    throw result.error;
  }, [mutate, sendRequest]);
};
